import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Route, Router, ActivatedRoute } from '@angular/router';
import { trigger, state, style, animate, transition } from '@angular/animations';

import { InformationService } from '../../../services/information.service';
import { BuildingService } from '../../../services/building.service';
import { SharedService } from '../../../services/shared.service';
import { TaxCredit } from '../../../viewmodel';
import { Animations } from '../../common/animations';

@Component({
    selector: 'app-taxcredit',
    templateUrl: './taxcredit.component.html',
    providers: [InformationService, BuildingService],
    animations: [Animations.flyInOut]
})
export class TaxCreditComponent implements OnInit {

    animate: string = 'active';
    animateDirection: number = -1;
    title: string = 'Tax credit';
    questionType: number = 706;
    projectId: number = 0;
    devProjectBuildingId: number = 0;
    siteProjectBuildingId: number = 0;
    buildingId: number = 0;
    //projBuildingId: number = 0;
    buildingAddress: string = '';
    pageError: any = [];
    pageSuccess: any = [];
    isEdit: boolean = false;
    submitted: boolean = false;
    questionForm: FormGroup;
    model: TaxCredit;

    constructor(private router: Router
        , private activeRoute: ActivatedRoute
        , private formBuilder: FormBuilder
        , private informationService: InformationService
        , private buildingService: BuildingService
        , private sharedService: SharedService) {

        this.model = new TaxCredit();
        this.model.ProjectId = this.projectId;
    }

    ngOnInit() {

        let ids = this.sharedService.getJsonData("id");
        if (ids != null) {
            if (ids.projectId != null)
                this.projectId = this.model.ProjectId = ids.projectId;
        }
        else {
            if (this.model.ProjectId == 0 && this.projectId == 0)
                this.sharedService.navigateHome();
        }

        let bqp = this.sharedService.getJsonData('BuildingQuestionParam');
        if (bqp != null) {
            this.devProjectBuildingId = this.model.DevProjectBuildingId = bqp.devProjectBuildingId;
            this.siteProjectBuildingId = this.model.SiteProjectBuildingId = bqp.siteProjectBuildingId;
            this.buildingId = this.model.BuildingId = bqp.bldgId;
            if (!(bqp.buildingAddress == null || bqp.buildingAddress == ''))
                this.buildingAddress = '- ' + bqp.buildingAddress;
        }
        else {
            this.sharedService.navigateSummary();
        }
        if (this.siteProjectBuildingId == null || this.buildingId == null)
            this.sharedService.navigateSummary();

        this.questionForm = this.formBuilder.group({
            isRequestingTaxCredits: ['', [Validators.required]],
            LIHTC4: [null],
            LIHTC9: [null],
            brownFields: [null],
            historic: [null],
            SLIHTC: [null],
            newMarkets: [null],
            hasOtherType: [null],
            otherTypeName: ['', Validators.required],
            sourceCitySubsidy: ['', Validators.required]            
        });        
        
        this.informationService.GetProjectBuildingTaxCredits(this.devProjectBuildingId, this.siteProjectBuildingId)
            .subscribe(
            success => {
                if (!success.Success)
                    this.showError(success.StatusMessage);
                else {
                    if (success.Result != null) {
                        this.isEdit = success.Result.IsValid;
                        this.PopulateData(success.Result);
                    }

                    if (this.model.ProjectId == 0 && this.projectId == 0)
                        this.showError("Project ID not found!")
                    else if (this.model.ProjectId == 0)
                        this.model.ProjectId = this.projectId;
                }
            },
            error => {
                if (error.status == 401)
                    this.router.navigateByUrl('/login?session=0');

                this.showError(error.ExceptionMessage)
            })

    }

    isTaxCreditValid(thisParam)
    {
        var result = !thisParam.model ? false :
            (thisParam.model.IsRequestingTaxCredits == 'true' && thisParam.submitted) &&

            ((thisParam.model.HasLIHTC4PercTaxCreditType == false || thisParam.model.HasLIHTC4PercTaxCreditType == null) &&
                (thisParam.model.HasLIHTC9PercTaxCreditType == false || thisParam.model.HasLIHTC9PercTaxCreditType == null) &&
                (thisParam.model.HasBrownFieldsTaxCreditType == false || thisParam.model.HasBrownFieldsTaxCreditType == null) &&
                (thisParam.model.HasHistoricTaxCreditType == false || thisParam.model.HasHistoricTaxCreditType == null) &&
                (thisParam.model.HasSLIHCTaxCreditType == false || thisParam.model.HasSLIHCTaxCreditType == null) &&
                (thisParam.model.HasNewMarketsTaxCreditType == false || thisParam.model.HasNewMarketsTaxCreditType == null) &&
                (thisParam.model.HasOtherTaxCreditType == false || thisParam.model.HasOtherTaxCreditType == null));

        return result;
    }

    PopulateData(building) {
        if (building == null || building.length == 0)
            return false;

        if (building.IsRequestingTaxCredits)
            this.model.IsRequestingTaxCredits = 'true';
        else
            this.model.IsRequestingTaxCredits = 'false';

        this.model.HasLIHTC4PercTaxCreditType = building.HasLIHTC4PercTaxCreditType;
        this.model.HasLIHTC9PercTaxCreditType = building.HasLIHTC9PercTaxCreditType;
        this.model.HasBrownFieldsTaxCreditType = building.HasBrownFieldsTaxCreditType;
        this.model.HasHistoricTaxCreditType = building.HasHistoricTaxCreditType;
        this.model.HasSLIHCTaxCreditType = building.HasSLIHCTaxCreditType;
        this.model.HasNewMarketsTaxCreditType = building.HasNewMarketsTaxCreditType;
        this.model.HasOtherTaxCreditType = building.HasOtherTaxCreditType;
        this.model.OtherTaxCreditTypeName = building.OtherTaxCreditTypeName;
        this.model.SourceCitySubsidy = building.SourceCitySubsidy;
        //this.model.HasHDCCitySubsidy = building.HasHDCCitySubsidy;
    }

    changeRequestingTaxCredits() {
        if (this.model.IsRequestingTaxCredits == 'false') {
            this.model.HasLIHTC4PercTaxCreditType = this.model.HasLIHTC9PercTaxCreditType = this.model.HasBrownFieldsTaxCreditType = this.model.HasHistoricTaxCreditType = this.model.HasSLIHCTaxCreditType = this.model.HasNewMarketsTaxCreditType = this.model.HasOtherTaxCreditType = false;
            this.model.SourceCitySubsidy = '';
            this.model.OtherTaxCreditTypeName = '';
        }
    }

    changeLIHTCPercent(cbType) {
       
        if (cbType == '4P') {
            this.model.HasLIHTC9PercTaxCreditType = false;
            this.model.SourceCitySubsidy = '';
        }
        else if (cbType == '9P') {
            this.model.HasLIHTC4PercTaxCreditType = false;
            this.model.SourceCitySubsidy = '';
        }

        if (this.model.HasLIHTC4PercTaxCreditType == false && this.model.HasLIHTC9PercTaxCreditType == false) {
            this.model.SourceCitySubsidy  = '';
        }
    }

    changeHasOtherType() { 
        if (this.model.HasOtherTaxCreditType == false) 
            this.model.OtherTaxCreditTypeName = '';
    }

    save(button) {
        this.submitted = true;
        //if (!this.questionForm.valid) 
        //    return false;

        var isValid = this.CheckFormValid();
        if (!isValid)
            return false;              
        
        this.model.IsValid = true;
        this.informationService.SaveProjectBuildingTaxCredits(this.model)
            .subscribe(
            success => {
                if (!success.Success){
                    this.showError(success.StatusMessage);
				}
                else {
                    if (button == 'NEXT') {
                       this.router.navigate(["/buildings/taxincentive"]);
                    }
                    else if (button == 'LATER')
                        this.sharedService.navigateSummary();
                }
            },
            error => {
                if (error.status == 401)
                    this.router.navigateByUrl('/login?session=0');

                this.showError(error.ExceptionMessage);
            })
    }

    CheckFormValid() {
        var isValid = true;
        if (this.model.IsRequestingTaxCredits == null || this.model.IsRequestingTaxCredits == '')
            isValid = false;
        else if ((this.model.IsRequestingTaxCredits == 'true') && ((this.model.HasLIHTC4PercTaxCreditType == false || this.model.HasLIHTC4PercTaxCreditType == null)
            && (this.model.HasLIHTC9PercTaxCreditType == false || this.model.HasLIHTC9PercTaxCreditType == null) && (this.model.HasBrownFieldsTaxCreditType == false || this.model.HasBrownFieldsTaxCreditType == null)
            && (this.model.HasHistoricTaxCreditType == false || this.model.HasHistoricTaxCreditType == null) && (this.model.HasSLIHCTaxCreditType == false || this.model.HasSLIHCTaxCreditType == null)
            && (this.model.HasNewMarketsTaxCreditType == false || this.model.HasNewMarketsTaxCreditType == null) && (this.model.HasOtherTaxCreditType == false || this.model.HasOtherTaxCreditType == null))) {

            isValid = false;
        }
        else if (this.model.HasOtherTaxCreditType == true && (this.model.OtherTaxCreditTypeName == null || this.model.OtherTaxCreditTypeName == ''))
            isValid = false;
        else if ((this.model.HasLIHTC4PercTaxCreditType == true || this.model.HasLIHTC9PercTaxCreditType == true)
            && ((this.model.SourceCitySubsidy == '' || this.model.SourceCitySubsidy == null)
               // && (this.model.HasHDCCitySubsidy == false || this.model.HasHDCCitySubsidy == null)
            ))
            isValid = false;

        return isValid;
    }

    previous() {
        //this.animateDirection = 1;
        if (this.devProjectBuildingId == null) 
            this.router.navigate(["/buildings/locationmihsiteunit"]);  //site building
        else 
            this.router.navigate(["/buildings/mihunits"]);     //dev or dev-Site building
    }

    home() {
        this.sharedService.navigateHome();
    }

    closeError() {
        this.pageError = [];
        this.pageSuccess = [];
    }

    showError(msg) {
        this.pageError = []; this.pageSuccess = [];
        this.pageError.push(this.sharedService.getCustomError(msg));
        this.sharedService.processError(msg);
    }
        
}
